var _this = this;
import * as tslib_1 from "tslib";
import getMailboxExportStatus from '../services/getMailboxExportStatus';
import { orchestrator } from 'satcheljs';
import setIsExportMailboxRequestMade from '../mutators/setIsExportMailboxRequestMade';
import setExportLink from '../mutators/setExportLink';
import setExportStatus from '../mutators/setExportStatus';
import checkMailboxExportStatus from '../actions/checkMailboxExportStatus';
export default orchestrator(checkMailboxExportStatus, function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var response;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getMailboxExportStatus()];
            case 1:
                response = _a.sent();
                if (response.ResponseClass === 'Error' && response.ResponseCode === 'ErrorItemNotFound') {
                    setIsExportMailboxRequestMade(false);
                }
                else {
                    setIsExportMailboxRequestMade(true);
                    if (response.UserConfiguration && response.UserConfiguration.Dictionary) {
                        response.UserConfiguration.Dictionary.forEach(function (dictionaryEntry) {
                            switch (dictionaryEntry.DictionaryKey.Value[0]) {
                                case 'Status':
                                    setExportStatus(dictionaryEntry.DictionaryValue.Value[0]);
                                    break;
                                case 'Link':
                                    setExportLink(dictionaryEntry.DictionaryValue.Value[0]);
                                    break;
                                default:
                                    break;
                            }
                        });
                    }
                }
                return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=checkStatusOfMailboxExport.js.map